import { pxToRem, theme } from '@pocketlaw/tetris';
import styled from 'styled-components';
export const Grid = styled.div `
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-template-rows: 2fr;
  align-content: center;
  place-items: stretch stretch;
  gap: 0 ${theme.spacing.lg};
`;
export const LabelContainer = styled.label `
  display: flex;
  flex-direction: column;
  padding: ${theme.spacing.md};
  border-radius: ${theme.borderRadius.md};
  border: ${pxToRem(1)} solid ${theme.semantic.border.default};
  gap: ${theme.spacing.md};
`;
